import React, { useState, useEffect } from "react";
import styles from "./ProgressBar.module.scss";

interface ProgressBarProps {
    value: number; // current progress (0–100)
    barColor?: string;
    hidePercentage?: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value, barColor= "#008C8F", hidePercentage = false}) => {
    return (
        <div className={styles.container}>
            <div
                className={styles.filler}
                style={{ backgroundColor: barColor, width: `${Math.min(Math.max(value, 0), 100)}%` }}
            >
                {!hidePercentage &&
                <span className={value < 30 ? styles.labelOutside : styles.label}>{value}%</span>}
            </div>
        </div>
    );
};

export default ProgressBar;
